import React from "react";
import PropTypes from "prop-types";
import DialogActions from "components/DialogActions";

const Actions = ({onSubmit, pageElementId, onClose}) => {
  return (
    <DialogActions
      onCancel={onClose}
      onClose={onSubmit}
      ctaText={pageElementId ? "Update" : "Create"}
    />
  );
};

Actions.propTypes = {
  onSubmit: PropTypes.func,
  pageElementId: PropTypes.number,
  onClose: PropTypes.func,
};

export default Actions;
